module.exports = __webpack_public_path__ + "static/media/truck.c705f96a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarType/images/truck.jpg
// module id = 530
// module chunks = 0